export default function SavedRequestVoter() {
    const canAccessSavedRequest = () => {
        return true;
    }

    return ({canAccessSavedRequest})
}
